module.exports = "../study/imgs/maps/Nagano/S8/Climate/Precipitation/Nagano_Precipitation_MIROC5_RCP45_Now.png";